"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUI = void 0;
var ClicksCounter_1 = require("./ClicksCounter");
var AudioButtonContainer_1 = require("./AudioButtonContainer");
var GameVars_1 = require("../../../GameVars");
var Utils_1 = require("../../../utils/Utils");
var BoardManager_1 = require("../BoardManager");
var GameConstants_1 = require("../../../GameConstants");
var GameManager_1 = require("../../../GameManager");
var AudioManager_1 = require("../../../AudioManager");
var GUI = /** @class */ (function (_super) {
    __extends(GUI, _super);
    function GUI(scene) {
        var _this = _super.call(this, scene) || this;
        _this.x = GameVars_1.GameVars.gameWidth / 2;
        _this.alertAchievements = null;
        _this.alertShop = null;
        _this.clicksCounter = new ClicksCounter_1.ClicksCounter(_this.scene);
        _this.add(_this.clicksCounter);
        _this.audioButtonContainer = new AudioButtonContainer_1.AudioButtonContainer(_this.scene);
        _this.audioButtonContainer.x = -GameVars_1.GameVars.gameWidth / 2 + 50;
        _this.audioButtonContainer.y = GameVars_1.GameVars.gameHeight - 120 * GameVars_1.GameVars.scaleY;
        _this.audioButtonContainer.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(_this.audioButtonContainer);
        _this.achievementsButton = new Utils_1.Button(_this.scene, -GameVars_1.GameVars.gameWidth / 2 + 50, GameVars_1.GameVars.gameHeight - 45 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "btn_achievements_off", "btn_achievements_on");
        _this.achievementsButton.onDown(_this.onClickAchievementsButton, _this);
        _this.achievementsButton.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(_this.achievementsButton);
        _this.shopButton = new Utils_1.Button(_this.scene, GameVars_1.GameVars.gameWidth / 2 - 65, GameVars_1.GameVars.gameHeight - 65 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "btn_shop_off", "btn_shop_on");
        _this.shopButton.onDown(_this.onClickShopButton, _this);
        _this.shopButton.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(_this.shopButton);
        if (GameVars_1.GameVars.modeGameData.iMaxItemUncovered >= GameConstants_1.GameConstants.RESTART_ITEM + GameVars_1.GameVars.modeGameData.restartCounter && GameVars_1.GameVars.modeGameData.restartCounter < 15) {
            _this.restartButton = new Utils_1.Button(_this.scene, GameVars_1.GameVars.gameWidth / 2 - 65, GameVars_1.GameVars.gameHeight - 170 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "btn_reset_off", "btn_reset_on");
            _this.restartButton.onDown(_this.onClickRestartButton, _this);
            _this.restartButton.scaleY = GameVars_1.GameVars.scaleY;
            _this.add(_this.restartButton);
        }
        if (GameVars_1.GameVars.gameData.isMode2Available) {
            _this.gameMode1Button = new Utils_1.Button(_this.scene, GameVars_1.GameVars.gameWidth / 2, 120 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "btn_game_mode_1_off", "btn_game_mode_1_on");
            _this.gameMode1Button.setOrigin(1, .5);
            _this.gameMode1Button.scaleY = GameVars_1.GameVars.scaleY;
            _this.gameMode1Button.onDown(_this.onClickGameMode, _this);
            _this.gameMode1Button.visible = GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_2;
            _this.add(_this.gameMode1Button);
            _this.gameMode2Button = new Utils_1.Button(_this.scene, GameVars_1.GameVars.gameWidth / 2, 120 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "btn_game_mode_2_off", "btn_game_mode_2_on");
            _this.gameMode2Button.setOrigin(1, .5);
            _this.gameMode2Button.scaleY = GameVars_1.GameVars.scaleY;
            _this.gameMode2Button.onDown(_this.onClickGameMode, _this);
            _this.gameMode2Button.visible = !_this.gameMode1Button.visible;
            _this.add(_this.gameMode2Button);
        }
        else {
            _this.gameMode1Button = null;
            _this.gameMode2Button = null;
        }
        if (!GameVars_1.GameVars.isDesktop && _this.gameMode1Button) {
            _this.gameMode1Button.setScale(.75, .75 * GameVars_1.GameVars.scaleY);
            _this.gameMode2Button.setScale(.75, .75 * GameVars_1.GameVars.scaleY);
        }
        if (GameConstants_1.GameConstants.DEVELOPMENT) {
            var resetButton = new Utils_1.Button(_this.scene, -GameVars_1.GameVars.gameWidth / 2 + 60, 145 * GameVars_1.GameVars.scaleY, "texture_atlas_0", "btn_reset_off", "btn_reset_on");
            resetButton.onDown(_this.onClickResetButton, _this);
            resetButton.scaleY = GameVars_1.GameVars.scaleY;
            _this.add(resetButton);
            var addCellButton = new Utils_1.Button(_this.scene, -GameVars_1.GameVars.gameWidth / 2 + 60, 90 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "btn_add_cell_off", "btn_add_cell_on");
            addCellButton.onDown(_this.onClickAddCellButton, _this);
            addCellButton.scaleY = GameVars_1.GameVars.scaleY;
            _this.add(addCellButton);
        }
        return _this;
    }
    GUI.prototype.update = function () {
        this.clicksCounter.update();
    };
    GUI.prototype.setVisible = function (value) {
        this.clicksCounter.changeVisible(value);
        return _super.prototype.setVisible.call(this, value);
    };
    GUI.prototype.showClicksCounter = function () {
        this.visible = true;
        this.audioButtonContainer.visible = false;
        this.achievementsButton.visible = false;
        this.shopButton.visible = false;
        this.clicksCounter.changeVisible(true);
    };
    GUI.prototype.onTutorialDone = function () {
        this.audioButtonContainer.visible = true;
        this.achievementsButton.visible = true;
        this.shopButton.visible = true;
    };
    GUI.prototype.showRestartButton = function () {
        if (!this.restartButton) {
            this.restartButton = new Utils_1.Button(this.scene, GameVars_1.GameVars.gameWidth / 2 - 65, GameVars_1.GameVars.gameHeight - 170 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "btn_reset_off", "btn_reset_on");
            this.restartButton.onDown(this.onClickRestartButton, this);
            this.restartButton.scaleY = GameVars_1.GameVars.scaleY;
            this.add(this.restartButton);
            this.restartHand = new Phaser.GameObjects.Image(this.scene, GameVars_1.GameVars.gameWidth / 2 - 85, GameVars_1.GameVars.gameHeight - 280 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "hand_tutorial_2");
            this.restartHand.setAngle(-90);
            this.restartHand.setScale(.9, -.9);
            this.add(this.restartHand);
            this.scene.tweens.add({
                targets: this.restartHand,
                y: this.restartHand.y + 20,
                scaleX: .8,
                scaleY: -.8,
                ease: Phaser.Math.Easing.Cubic.In,
                duration: 250,
                repeat: -1,
                yoyo: true
            });
            var that = this;
            setTimeout(function () {
                if (that.restartHand) {
                    that.restartHand.visible = false;
                }
            }, 5000);
        }
    };
    GUI.prototype.showGameModeButtons = function () {
        this.gameMode1Button = new Utils_1.Button(this.scene, GameVars_1.GameVars.gameWidth / 2, 120 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "btn_game_mode_1_off", "btn_game_mode_1_on");
        this.gameMode1Button.setOrigin(1, .5);
        this.gameMode1Button.scaleY = GameVars_1.GameVars.scaleY;
        this.gameMode1Button.onDown(this.onClickGameMode, this);
        this.gameMode1Button.visible = GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_2;
        this.add(this.gameMode1Button);
        this.gameMode2Button = new Utils_1.Button(this.scene, GameVars_1.GameVars.gameWidth / 2 + 200, 120 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "btn_game_mode_2_off", "btn_game_mode_2_on");
        this.gameMode2Button.setOrigin(1, .5);
        this.gameMode2Button.scaleY = GameVars_1.GameVars.scaleY;
        this.gameMode2Button.onDown(this.onClickGameMode, this);
        this.gameMode2Button.visible = !this.gameMode1Button.visible;
        this.add(this.gameMode2Button);
        if (!GameVars_1.GameVars.isDesktop) {
            this.gameMode1Button.setScale(.75, .75 * GameVars_1.GameVars.scaleY);
            this.gameMode2Button.setScale(.75, .75 * GameVars_1.GameVars.scaleY);
        }
        this.scene.tweens.add({
            targets: this.gameMode2Button,
            x: GameVars_1.GameVars.gameWidth / 2,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250
        });
    };
    GUI.prototype.markButton = function (name) {
        var alert;
        if (name === GameConstants_1.GameConstants.SHOP) {
            if (!this.alertShop) {
                this.alertShop = new Phaser.GameObjects.Image(this.scene, this.shopButton.x + 40, this.shopButton.y - 40 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "alert");
                this.alertShop.scaleY = GameVars_1.GameVars.scaleY;
                this.add(this.alertShop);
                alert = this.alertShop;
            }
        }
        else {
            if (!this.alertAchievements) {
                this.alertAchievements = new Phaser.GameObjects.Image(this.scene, this.achievementsButton.x + 22, this.achievementsButton.y - 22 * GameVars_1.GameVars.scaleY, "texture_atlas_1", "alert");
                this.alertAchievements.scaleY = GameVars_1.GameVars.scaleY;
                this.add(this.alertAchievements);
                alert = this.alertAchievements;
            }
        }
        this.scene.tweens.add({
            targets: alert,
            scaleX: 1.075,
            scaleY: 1.075 * GameVars_1.GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 150,
            yoyo: true,
            repeat: -1
        });
    };
    GUI.prototype.unmarkButton = function (name) {
        if (name === GameConstants_1.GameConstants.SHOP) {
            if (this.alertShop) {
                this.alertShop.destroy();
                this.alertShop = null;
            }
        }
        else {
            if (this.alertAchievements) {
                this.alertAchievements.destroy();
                this.alertAchievements = null;
            }
        }
    };
    GUI.prototype.onClickGameMode = function () {
        if (GameVars_1.GameVars.paused) {
            return;
        }
        GameManager_1.GameManager.switchGameMode();
        this.gameMode1Button.visible = GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1;
        this.gameMode2Button.visible = !this.gameMode1Button.visible;
        AudioManager_1.AudioManager.playSound("click_button");
    };
    GUI.prototype.onClickAchievementsButton = function () {
        if (GameVars_1.GameVars.paused || GameVars_1.GameVars.carouselActive) {
            return;
        }
        if (this.alertAchievements) {
            this.alertAchievements.destroy();
            this.alertAchievements = null;
        }
        BoardManager_1.BoardManager.showScrollingLayer(GameConstants_1.GameConstants.ACHIEVEMENTS);
        AudioManager_1.AudioManager.playSound("click_button");
    };
    GUI.prototype.onClickShopButton = function () {
        if (GameVars_1.GameVars.paused || GameVars_1.GameVars.carouselActive) {
            return;
        }
        if (this.alertShop) {
            this.alertShop.destroy();
            this.alertShop = null;
        }
        BoardManager_1.BoardManager.showScrollingLayer(GameConstants_1.GameConstants.SHOP);
        AudioManager_1.AudioManager.playSound("click_button");
    };
    GUI.prototype.onClickRestartButton = function () {
        if (GameVars_1.GameVars.paused || GameVars_1.GameVars.carouselActive) {
            return;
        }
        if (this.restartHand) {
            this.restartHand.destroy();
            this.restartHand = null;
        }
        BoardManager_1.BoardManager.showRestartLayer();
        AudioManager_1.AudioManager.playSound("click_button");
    };
    GUI.prototype.onClickResetButton = function () {
        if (GameVars_1.GameVars.paused || GameVars_1.GameVars.carouselActive) {
            return;
        }
        GameManager_1.GameManager.resetGame();
    };
    GUI.prototype.onClickAddCellButton = function () {
        if (GameVars_1.GameVars.paused || GameVars_1.GameVars.carouselActive) {
            return;
        }
        BoardManager_1.BoardManager.showLevelUpLayer();
    };
    return GUI;
}(Phaser.GameObjects.Container));
exports.GUI = GUI;
